import { Link } from "react-router-dom";
import { BRAND } from "@/brand.config";

export default function AboutProgram() {
  const highlights = [
    { h: "Free to join", b: `No fee and no waitlist. Join at a participating ${BRAND.name} store or online.` },
    { h: "Designed around you", b: "Your points, tier and privileges follow one mobile-linked membership journey." },
    { h: "Rooted in craft", b: "Privileges meet the sarees, lehengas, suits and occasion wear Odhni has celebrated since 1999." },
  ];
  return (
    <div className="max-w-[1100px] mx-auto px-6 lg:px-12 py-20" data-testid="page-about">
      <div className="text-[11px] uppercase tracking-[0.3em] kazo-text-burgundy mb-4">ABOUT THE PROGRAMME</div>
      <h1 className="editorial-headline text-5xl lg:text-7xl mb-8">A celebration<br /><em className="font-light">of belonging.</em></h1>
      <div className="max-w-3xl text-neutral-700 leading-relaxed text-lg" data-testid="about-program-description">
        <p>{BRAND.loyaltyProgramName} is Odhni&apos;s official loyalty programme — a thoughtful thank-you for choosing us for the occasions that matter.</p>
        <p className="mt-6">Every benefit, tier and point rule is managed transparently through the active programme configuration.</p>
      </div>
      <div className="grid md:grid-cols-3 gap-8 mt-16">
        {highlights.map((item) => <div key={item.h} className="border border-black/10 p-8 bg-white"><h3 className="font-display text-2xl mb-2">{item.h}</h3><p className="text-sm text-neutral-600 leading-relaxed">{item.b}</p></div>)}
      </div>
      <Link to="/" className="mt-12 inline-block k-btn kazo-bg-burgundy text-white uppercase tracking-widest text-xs" data-testid="about-join-link">Join now</Link>
    </div>
  );
}